/**
 * Rule sub-type, set only when a node's type is Rule.
 * Mirrors Osstre.Domain WorkflowNodeRuleType.
 */
export enum WorkflowNodeRuleType {
  /** Branches true/false on a boolean expression */
  Condition = 'condition',
  /** Waits for a trigger event before proceeding */
  WaitForTrigger = 'waitForTrigger',
  /** Waits for a duration before proceeding */
  TimeDelay = 'timeDelay'
}
